// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2HTkl","addWidgetButton":"Header_addWidgetButton__3P92V","dashboardTabs":"Header_dashboardTabs__2WQlD","active":"Header_active__oxxgo"};